import React from 'react'
import styled from 'styled-components'
import theme from '../../theming'

const Frame = styled.div`
    margin: ${theme.space.medium};
`

export default Frame
